<template>
  <div data-app>
    <v-card>
      <v-card-title>
        Árlista
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('FORMS.search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <PriceListModalForm
            :loader="loader"
            :modalData="modalData"
            :statuses="statuses"
            :permissions="permissions"
            :currencyCollection="currencyCollection"
            :productCollection="productCollection"
            @closeModalForm="handleCloseModalForm"
            @saveModalForm="handleSaveModalForm"
          ></PriceListModalForm>
        </v-col>
      </v-row>

      <AlertComponent
        :alertShow="alert.show"
        :alertText="alert.text"
        @closeAlert="alert.show = false"
      ></AlertComponent>
      <v-data-table
        :headers="headers"
        :items="collection"
        :search="search"
        :sort-by="['name']"
        @click:row="handleClickItem"
      >
        <template v-slot:item.status="{ item }">
          <span v-if="statuses.system">{{
            statuses.products.product[item.status].value
          }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            @click="deleteItem(item)"
            v-if="permissionCan('delete')"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this item?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ApiService from "@/core/services/api.service";
import AlertComponent from "@/view/components/AlertComponent";
// import i18nService from "@/core/services/i18n.service.js";
import PriceListModalForm, { initialFormData } from "./PriceListModalForm";
import SiteService from "@/core/services/site.service.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "PriceLists",
  components: { PriceListModalForm, AlertComponent },
  data() {
    return {
      loader: false,
      showAll: false,
      search: "",
      collection: [],
      permissions: [],
      alert: {
        show: false,
        text: "You can't delete a price list that contains items",
      },
      headers: [
        {
          text: this.$t("PRICE_LIST.priceListName"),
          value: "name",
        },
        {
          text: this.$t("PRICE_LIST.defaultTaxName"),
          value: "vat_name",
        },
        {
          text: this.$t("PRICE_LIST.defaultTaxRate"),
          value: "vat_value",
        },
        {
          text: this.$t("PRICE_LIST.currency"),
          value: "currency_id",
        },
        { text: this.$t("TABLE.status"), value: "status" },
        { text: this.$t("TABLE.actions"), value: "actions", sortable: false },
      ],

      modalData: {
        dialog: false,
        editedIndex: -1,
        editedItem: Object.assign({}, initialFormData()),
      },

      dialogDelete: false,
    };
  },

  computed: {
    ...mapGetters([
      "priceListCollection",
      "statuses",
      "currencyCollection",
      "productCollection",
    ]),

    endPoint() {
      return "products/admin/" + SiteService.getActiveSiteId() + "/priceList/";
    },
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    // showAll() {
    //   if (this.companyTypeCollection.length > 0) {
    //     this.filterCollection(this[DEPARTMENT_COLLECTION]);
    //   }
    // },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
    priceListCollection(val) {
      this.filterCollection(val);
    },
  },

  methods: {
    ...mapActions([
      "fetchCurrency",
      "fetchPriceList",
      "fetchProduct",
      // "fetchQuantityUnit",
    ]),
    editItem(id) {
      this.loader = true;
      this.modalData.dialog = true;
      ApiService.get(this.endPoint + id)
        .then(({ data }) => {
          this.modalData.editedIndex = 1;
          // let appLocale = i18nService.getActiveLanguage();
          data.products = data.products
            .map((item) => {
              item.item = {
                ...this.$store.getters.getProductByID(item.product_id),
              };

              item.name = item.item.name;

              // if (item.translations.length == 0) {
              //   item.name = "Name not defined";
              //   return item;
              // }
              // if (item.translations[appLocale]) {
              //   item.name = item.translations[appLocale].name;
              // } else {
              //   item.name =
              //     item.translations[Object.keys(item.translations)[0]].name;
              // }

              // let qu = this.$store.getters.getQuantityUnitByID(
              //   item.quantity_unit_id
              // );

              // if (typeof qu == "object") {
              //   item.quantityUnitTranslated = qu.name;
              // }

              // item.item = { ...this.$store.getters.getProductByID(item.item_id) };

              return item;
            })
            .filter(
              (item) =>
                item.name && (item.price_net > 0 || item.price_gross > 0)
            );

          this.modalData.editedItem = Object.assign({}, data);

          this.modalData.dialog = true;
        })
        .catch((error) => {
          console.log("Error!: ", error);
        })
        .finally(() => {
          this.loader = false;
        });
    },

    deleteItem(item) {
      this.editedIndex = this.priceListCollection.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      ApiService.delete(this.endPoint + this.editedItem.id)
        .then(() => {
          this.fetchPriceList();
          this.fetchCurrency();
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
      this.closeDelete();
    },

    handleCloseModalForm() {
      this.modalData.dialog = false;
      this.modalData.editedIndex = -1;

      this.modalData.editedItem = Object.assign({}, initialFormData());
      if (this.$route.name !== "pricelists")
        this.$router.push({ name: "pricelists" });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },

    handleSaveModalForm(model) {
      this.loader = true;
      if (model.id) {
        ApiService.put(this.endPoint + model.id, model)
          .then(() => {
            this.fetchPriceList();
            this.handleCloseModalForm();
          })
          .catch((error) => {
            console.log("Error!: ", error);
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        //create model
        ApiService.post(this.endPoint, model)
          .then(() => {
            this.fetchPriceList();
            this.handleCloseModalForm();
          })
          .catch((error) => {
            console.log("Error!: ", error);
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },

    filterCollection(coll) {
      if (!this.showAll) {
        this.collection = coll;
      } else {
        this.collection = coll.filter((item) => {
          return item.status == 1;
        });
      }
    },

    handleClickItem(item) {
      if (this.permissionCan("view") && !this.dialogDelete) {
        this.$router.push(`/products/pricelists/${item.id}`);
      }
    },

    permissionCan(action) {
      return this.permissions.find(
        (x) => x.name == "products.price_list." + action
      );
    },

    setPermissions() {
      if (localStorage.permissions) {
        this.permissions = JSON.parse(localStorage.permissions).filter(
          (item) => item.name.indexOf("price_list") > -1
        );
      }
    },
  },

  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Price list" }]);
    this.fetchCurrency();
    this.fetchPriceList();
    this.fetchProduct();
    this.setPermissions();
    // this.fetchQuantityUnit();
  },
};
</script>
